import { FC } from "react";

type GameDateProps = {
  georgianDate?: string;
};

const GameDate: FC<GameDateProps> = ({ georgianDate }) => (
  <div style={{ textAlign: "right" }}>
    <span
      style={{
        lineHeight: 1.5,
        paddingTop: 0.5,
        color: "#fff",
      }}
    >
      {georgianDate}
    </span>
  </div>
);

export default GameDate;
